<template>
  <add-edit-dialog>
    <crm-panel :title="title">
      <div class="page-buttons">
        <crm-button
          :text="'保存'"
          :disabled="isSubmitDisabled"
          @click="handleSave()">
        </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleClose()">
        </crm-button>
      </div>
      <div style="margin-top: 20px">
        <el-form label-position="right" label-width="120px" :rules="rules" ref="addForm" :model="addForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同编号:" prop="contractNo">
               <el-input v-model="addForm.contractNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商名称:" prop="supplierName">
                <el-input v-model="addForm.supplierName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="12">
              <el-form-item label="合同金额(元)：" prop="contractAmount">
                <el-input v-model="addForm.contractAmount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签订日期：" prop="signedDateStr">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  :editable="false"
                  v-model="addForm.signedDateStr"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="结算方式：" prop="settlementType">
                <el-select v-model="addForm.settlementType">
                  <el-option
                    v-for="item in settlementList"
                    :key="item.uid"
                    :label="item.name"
                    :value="item.uid"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务员" prop="salesmanCode">
               <el-select v-model="addForm.salesmanCode">
                 <el-option
                  v-for="item in spendSalesList"
                  :key="item.code"
                  :label="item.userName"
                  :value="item.code"
                 />
               </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：" prop="remarks">
                <el-input
                  type="textarea"
                  placeholder="不超过200字"
                  :rows="4"
                  v-model="addForm.remarks"
                  name="remarks">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CrmButton from '@/components/base/crmButton';
import crmPanel from '@/components/base/crmPanel';
import AddEditDialog from '@/components/base/addEditDialog';

export default {
  components: {
    CrmButton,
    crmPanel,
    AddEditDialog,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    const totalMoneyRule = (rule, value, callback) => {
      if (value && !/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value && value > 9999999.99) {
        callback(new Error('最大9999999.99'));
      } else {
        callback();
      }
    };
    return {
      addForm: {},
      type: 'add',
      title: '新增支出合同',
      rules: {
        contractAmount: [
          { validator: totalMoneyRule, trigger: 'blur' },
        ],
        salesmanCode: [
          { required: true, message: '请选择业务员', trigger: 'change' },
        ],
        signedDateStr: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
        supplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'change' },
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        contractNo: [
          { required: true, message: '请输入供合同编号', trigger: 'change' },
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        remarks: [
          { max: 200, message: '不超过200个字', trigger: 'blur' },
        ],
      },
      isSubmitDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      spendSalesList: 'compact/spendSalesList',
      spendDetail: 'compact/spendDetail',
      settlementList: 'common/settlementList',
    }),
  },
  created() {
    this.getSpendSales();
    if (this.id) {
      this.title = '编辑支出合同';
      this.type = 'update';
    }
    // 获取结算方式
    this.getSettlementSource();
    this.initForm();
  },
  methods: {
    ...mapActions({
      getSpendSales: 'compact/getSpendSales',
      addApiSupport: 'compact/addApiSupport',
      updateApiSupport: 'compact/updateApiSupport',
      getDetailApiSupport: 'compact/getDetailApiSupport',
      getSettlementSource: 'common/getSettlementSource',
    }),
    initForm() {
      if (this.id) {
        this.getDetailApiSupport({ id: this.id }).then(() => {
          this.addForm = {
            id: this.spendDetail.id,
            contractNo: this.spendDetail.contractNo,
            contractAmount: this.spendDetail.contractAmount,
            supplierName: this.spendDetail.supplierName,
            settlementType: this.spendDetail.settlementType,
            signedDateStr: this.spendDetail.signedDateStr,
            salesmanCode: this.spendDetail.salesmanCode,
            remarks: this.spendDetail.remarks,
          };
        });
      } else {
        this.initAddForm();
      }
    },
    initAddForm() {
      this.addForm = {
        contractNo: null,
        contractAmount: '',
        supplierName: '',
        settlementType: '',
        signedDateStr: '',
        salesmanCode: '',
        remarks: '',
      };
    },
    handleClose() {
      this.$emit('close');
      this.initAddForm();
    },
    handleSave() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;
          this[`${this.type}ApiSupport`]({
            ...this.addForm,
          }).then(() => {
            this.$message({
              type: 'success',
              message: this.type === 'add' ? '新增成功' : '修改成功',
            });
            this.$emit('close');
            this.$emit('success');
            this.initAddForm();
          }).finally(() => {
            this.isSubmitDisabled = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.addcost-container {
  padding-right: 30px;
  .dialog-footer{
    text-align: right;
  }
  .el-date-editor.el-input{
    width: 100%;
  }
}
</style>
